import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { concat, map, Observable } from 'rxjs';
import { PostUnit, PutUnit, Unit } from 'src/app/interfaces/api/unit';
import { ApiService } from '../../core/api.service';
import { RequestService } from '../../core/request.service';
import { WebSocketService } from '../../core/web-socket.service';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})

export class UnitService {

  collection = "Unit";
  collectionPath = "units";
  units: Unit[] = [];

  constructor(
    public http: HttpClient,
    private request: RequestService,
    private socket: WebSocketService,
    private apiService: ApiService
  ) { }

  //---GET---//

  getUnits(query: QueryParams = {}): Observable<Unit[]> {
    return concat(
      this.request.getCollection(this.collection, this.collectionPath, query),
      this.socket.getUpdate(this.collection)
    )
  }

  findUnits(query: QueryParams = {}): Observable<Unit[]> {
    return this.apiService.getCollection(this.collectionPath, '', query);
  }

  getUnitsCount(query: QueryParams = {}): Observable<number> {
    return this.request.getCollection(this.collection, this.collectionPath, query).pipe(
      map(units => units.length)
    );
  }

  getUnit(id: string): Observable<Unit> {
    return this.request.getItem(this.collection, this.collectionPath, id)
  }

  //---POST---//

  addUnit(unit: PostUnit): Observable<Unit> {
    return this.request.postItem(this.collection, this.collectionPath, unit);
  }

  //---PUT---//

  updateUnit(unit: PutUnit): Observable<any> {
    return this.request.setProjectData(this.collection, this.collectionPath, unit);
  }

  //---DELETE---//

  removeUnit(unitId: string): Observable<any> {
    return this.request.deleteItem(this.collection, this.collectionPath, unitId);
  }

  removeUnits(query: QueryParams): Observable<any> {
    return this.request.deleteManyItems(this.collection, this.collectionPath, query);
  }
}
